import { EVENTS } from '../constants/webSocketConsts/events';
import {
  handleInsertedCompanies,
  handleModifiedCompanies,
  handleDeletedCompanies,
} from '../store/clients/actions';

const CompanyHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
      return handleInsertedCompanies(items);
    case EVENTS.MODIFY:
      return handleModifiedCompanies(items);
    case EVENTS.REMOVE:
      return handleDeletedCompanies(items);
    default:
      break;
  }
  return null;
};

export default CompanyHandler;
